import { useRef } from 'react';
import { useMenuBackground } from './useMenuBackground';
import './styles.css';

export const MenuBackground = () => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    useMenuBackground(canvasRef);
    return <canvas ref={canvasRef} className="menu__canvas" aria-hidden="true" />;
};
